import { AiImageGeneratorComponentBuilder } from './component/aiImageGenerator/aiImageGeneratorComponentBuilder';
import { AiVectorGenerationAppComponentBuilder } from './component/aiVectorGenerator/aiVectorGenerationAppComponentBuilder';
import { BackgroundRemoverComponentBuilder } from './component/backgroundRemover/backgroundRemoverComponentBuilder';
import { BenefitsRowComponentBuilder } from './component/benefitsRow/benefitsRowComponentBuilder';
import { BottomBannerComponentBuilder } from './component/bottomBanner/bottomBannerComponentBuilder';
import { BreadcrumbsComponentBuilder } from './component/breadcrumb/breadcrumbsComponentBuilder';
import { TextImageTextComponentBuilder } from './component/bulkText/textImageTextComponentBuilder';
import { FaqComponentBuilder } from './component/frequentlyAskedQuestions/faqComponentBuilder';
import { HeaderBannerComponentBuilder } from './component/headerBanner/headerBannerComponentBuilder';
import { HeroSectionComponentBuilder } from './component/heroSection/heroSectionComponentBuilder';
import { ImageSectionComponentBuilder } from './component/imageText/imageSectionComponentBuilder';
import { KeyPointsColumnAutoFilledComponentBuilder } from './component/keyPointsColumnAutoFilled/KeyPointsColumnAutoFilledComponentBuilder';
import { ImageSectionSingleComponentBuilder } from './component/mediaSpotlight/imageSectionSingleComponentBuilder';
import { OtherPagesAutoFilledComponentBuilder } from './component/otherPagesAutoFilled/otherPagesAutoFilledComponentBuilder';
import { SeoComponentBuilder } from './component/seo/seoComponentBuilder';
import { TextMediaCardComponentBuilder } from './component/shared/KeyPointsColumn/textMediaCardComponentBuilder';
import { StepsComponentBuilder } from './component/steps/stepsComponentBuilder';
import { TemplateFeedComponentBuilder } from './component/templateFeed/templateFeedComponentBuilder';
import { TestimonialComponentBuilder } from './component/testimonial/testimonialComponentBuilder';
import { TextWithTitleComponentBuilder } from './component/textWithTitle/textWithTitleComponentBuilder';
import { VectorizerComponentBuilder } from './component/vectorizer/vectorizerComponentBuilder';
import { ComponentBuilder } from './componentBuilder';

export const allStrapiComponents = [
  new BreadcrumbsComponentBuilder(),
  new BenefitsRowComponentBuilder(),
  new SeoComponentBuilder(),
  new HeaderBannerComponentBuilder(),
  new HeroSectionComponentBuilder(),
  new ImageSectionComponentBuilder(),
  new TestimonialComponentBuilder(),
  new ImageSectionSingleComponentBuilder(),
  new TextMediaCardComponentBuilder(),
  new StepsComponentBuilder(),
  new FaqComponentBuilder(),
  new BottomBannerComponentBuilder(),
  new KeyPointsColumnAutoFilledComponentBuilder(),
  new OtherPagesAutoFilledComponentBuilder(),
  new TextImageTextComponentBuilder(),
  new TemplateFeedComponentBuilder(),
  new AiVectorGenerationAppComponentBuilder(),
  new AiImageGeneratorComponentBuilder(),
  new VectorizerComponentBuilder(),
  new TextWithTitleComponentBuilder(),
  new BackgroundRemoverComponentBuilder(),
];

export type StrapiComponentKey = (typeof allStrapiComponents)[0]['key'];

export const allStrapiComponentsMap = allStrapiComponents.reduce(
  (previous, current) => {
    return {
      [current.key]: current,
      ...previous,
    };
  },
  {} as Record<string, ComponentBuilder>
);
